import { ComingSoonPage } from "../components/ComingSoonPage";

export function ExportsPage() {
	return (
		<ComingSoonPage
			title="Exports"
			subtitle="CSV (Essential+) and Parquet (Pro). Watermarked with your manufacturer slug + timestamp."
			arrivesIn="v1.0 (mid-v0)"
			detail={[
				"Files generated asynchronously and delivered via signed URL.",
				"Files expire after 7 days; the underlying R2 object is purged.",
				"Each export includes a README.md with cohort thresholds + citation snippet.",
			]}
		/>
	);
}
